import { login as _login, logout as _logout, getInfo as _getInfo, loginPerson } from "@/api/user";
import { getToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";
import { clearTheme } from "@/utils/theme";
var state = {
  token: getToken(),
  name: "",
  email: "",
  type: "",
  id: 1,
  avatar: "",
  gotInfo: false,
  // already get user info
  rule: [],
  referrerCode: "",
  pmsCodes: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_GOT_INFO: function SET_GOT_INFO(state, got) {
    state.gotInfo = got;
  },
  SET_LOGO: function SET_LOGO(state, logo) {
    state.avatar = logo;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_ROLE: function SET_ROLE(state, rule) {
    state.rule = rule;
  },
  SET_EMAIL: function SET_EMAIL(state, email) {
    state.email = email;
  },
  SET_TYPE: function SET_TYPE(state, type) {
    state.type = type;
  },
  SET_PMS_CODE: function SET_PMS_CODE(state, payload) {
    state.pmsCodes = payload;
  },
  SET_REFERRER_CODE: function SET_REFERRER_CODE(state, payload) {
    state.referrerCode = payload;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var email = userInfo.email,
      password = userInfo.password,
      code = userInfo.code;
    return new Promise(function (resolve, reject) {
      _login({
        mail: email.trim(),
        password: password,
        login_type: 1
      }, code).then(function (res) {
        commit("SET_EMAIL", email);
        commit("SET_TYPE", 1);
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  personLogin: function personLogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    var email = userInfo.email,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      loginPerson({
        mail: email.trim(),
        password: password,
        login_type: 4
      }).then(function (res) {
        commit("SET_EMAIL", email);
        commit("SET_TYPE", 4);
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      _getInfo().then(function (response) {
        var result = response.result;
        commit("SET_GOT_INFO", true);
        commit("SET_LOGO", result.logo || "");
        commit("SET_NAME", result.cust_name || "");
        commit("SET_ROLE", result.role || "");
        commit("SET_EMAIL", result.mail || "");
        commit("SET_PMS_CODE", result.list_per_code || []);
        commit("SET_REFERRER_CODE", result.invitation_code);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function (res) {
        commit("SET_TOKEN", "");
        commit("SET_GOT_INFO", false);
        commit("SET_LOGO", "");
        commit("SET_NAME", "");
        commit("SET_ROLE", []);
        commit("SET_PMS_CODE", []);
        commit("SET_REFERRER_CODE", "");
        removeToken();
        resetRouter();
        clearTheme();
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit("SET_TOKEN", "");
      commit("SET_GOT_INFO", false);
      commit("SET_LOGO", "");
      commit("SET_NAME", "");
      commit("SET_ROLE", []);
      commit("SET_PMS_CODE", []);
      commit("SET_REFERRER_CODE", "");
      removeToken();
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};